import CloseIcon from '@mui/icons-material/Close'
import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps, connectField, filterDOMProps, joinName, useField } from 'uniforms'

export type ListDelFieldProps = FieldProps<unknown, IconButtonProps, { icon?: ReactNode }>

function ListDel({ disabled, icon = <CloseIcon />, name, readOnly, ...props }: ListDelFieldProps) {
  const { t } = useTranslation('@cibo/ui/Uniforms')

  const nameParts = joinName(null, name)
  const nameIndex = +nameParts[nameParts.length - 1]
  const parentName = joinName(nameParts.slice(0, -1))
  const parent = useField<{ minCount?: number }, unknown[]>(
    parentName,
    {},
    { absoluteName: true }
  )[0]

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  disabled ||= readOnly || parent.minCount! >= parent.value!.length

  return (
    <Tooltip title={t('removeEvent')}>
      <IconButton
        {...filterDOMProps(props)}
        disabled={disabled}
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          const value = parent.value!.slice()
          value.splice(nameIndex, 1)
          parent.onChange(value)
        }}
        color="primary"
        size="small"
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}

export default connectField<ListDelFieldProps>(ListDel, {
  initialValue: false,
  kind: 'leaf',
})
